module.exports = __webpack_public_path__ + "static/media/thankyou_page_image.85aca6b4.svg";